const defaultFundManagerTitle = 'Portfolio Manager';
const useScrollPositionHighFPS = 240;

export {
  defaultFundManagerTitle,
  useScrollPositionHighFPS,
};
